<template>
  <div class="pinch-in-toparea">
    <div class="modal-inner flexcenter">
      <div class="pinch-in">
        <button class="modal-close" @click="clickClose"></button>
        <div class="pinch-inInner pinch-toparea">
          <div class="item flexbox">
            <!--<button class="icon-pinch-close"></button>-->
            <template v-if="pathstep.mode == 'STile'">
              <div class="buttons">
                <template v-if="choiceNum == 1">
                  <button class="icon-num1"></button>
                </template>
                <template v-else>
                  <button class="icon-num2"></button>
                </template>
                <button class="icon-voice" @click="queAudioPlay"></button>
              </div>
            </template>
            <div class="text" :class="getPinchInTextFontClassQue(pinchInText, $parent.productLanguage)" v-html="pinchInText"></div>
            <button v-if="pathstep.mode != 'STile'"  v-show="pinchInShowVoice" class="icon-voice" @click="queAudioPlay"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 共通処理
import common from '@/mixin/common'
import runmode from '@/mixin/runmode'

export default {
  name: 'PinchInQue',
  props: {
    pinchInText: String,
    pathstep: Object,
    choiceNum: Number,
    pinchInShowVoice: Boolean,
    pinchInSound: String,
  },
  mixins: [
    common,
    runmode
  ],
  data() {
    return {
      
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /**
     * 閉じるボタン押下時の処理
     */
    clickClose: function() {
      this.log("PinchInAct start clickClose");
      
      // 再生中の音声停止
      this.$emit('pinchInaudioPause')
      // 音声アイコン活性化
      this.enabledIconVoice()
      
      this.$emit('pinchOut')
    },
    queAudioPlay: function() {
      // オーディオ再生
      if (this.pinchInSound) {
        this.$emit('pinchiInAudioPlay', this.pinchInSound)
      }
    }
  },
  mounted: function () {
  },
  watch: {
  },
}
</script>

<style lang="scss" scoped>
  @import 'src/assets/style/card';
</style>



// WEBPACK FOOTER //
// PinchInQue.vue?16845dfc